// extracted by mini-css-extract-plugin
export default {"tradeInItemsContainer":"trade-in-details_tradeInItemsContainer__abe32","modalView":"trade-in-details_modalView__3838a"};